import { EARLY_LEARNING_PROGRAM, ELEMENTARY_SCHOOL_PROGRAM, PRINTABLES } from "../../../constant-data/constants";
import { CompleteOnboarding, TrackWeeklyGoalOnboarding } from "../../../services/parent-api";
import { isDRSWithCategoryExpansion } from "../../../utils/feature_mapping";
import { getItemFromLocalStorage, hasSignedUpFromWs, saveHeaderVariationInStorage, setDefaultTabPrintablesInStorage, skipGradesForSubjectSelection } from "../../../utils/web-helper";
import { TypesOfModes } from "../../gamification/header-banner/typeOfModes";


export const IsElaAvailabeForGrade = (gradeId, subjectGradeMap) => {
  const courses = coursesFromSubjectGradeMap(subjectGradeMap);
  return courses.filter(course => course.grade_id === gradeId).length > 1;
}

export const getCourseFromSubject = (gradeId, subjectId, subjectGradeMap) => {
  return [...subjectGradeMap.get(subjectId).values()].filter(arr => arr.grade_id === gradeId)[0];
}

export const coursesFromSubjectGradeMap = (subjectGradeMap) => {
  let courses = [];
  [...subjectGradeMap.values()].forEach(arr => courses = [...courses, ...arr]);
  return courses;
}

// whenever we add a step we add a key value to this and we would need to modify all the functions (steps) which
// would lead to the newly added step.

const childScreenNameNextStep = ({skipSubjectForPrekAndK, isElaAvailabeForGrade, skipPOQ, selectedSubject, isPreKindergarten }) => {
  return isDRSWithCategoryExpansion() ? 'program_selection_screen' : 'grade_selection';
}

const gradeSelectionNextStep = ({skipSubject, isElaAvailabeForGrade, skipPOQ, selectedSubject, isPreKAndK, deleteAll }) =>{
  const { selectedProgram } = getItemFromLocalStorage('splashverse-onboarding');
  if(isPreKAndK && selectedProgram !== ELEMENTARY_SCHOOL_PROGRAM){
    return 'age_selection';
  } else {
    // return `onboarding_questions_${selectedSubject}`;
    return 'persona_identification';
  }
}

const ageSelectionNextStep = ({isPrek }) => {
    return 'persona_identification';
}

const subjectSelectionNext = ({ skipPOQ, selectedSubject, isPreKindergarten }) => {
//  if (skipPOQ) {
//     return 'purchase_page';
//   }
  return `onboarding_questions_${selectedSubject}`;
}

const onboardingQuestionsNext = ({ selectedSubject, isMentorAlloted, isLPABTest }) => {
  // const showNewPoqFlow = getABTestValue('Parent', 'NewPOQFlow') === "Variant" ? true : false;

  // return 'weekly_goal_screen';
  return `building_focus_area_${selectedSubject}`;

  // if(isLPABTest)
  // {
  //   if(showNewPoqFlow){
  //     return `building_focus_area_${selectedSubject}`;
  //   }
  //   return 'learning_partner_mapping_screen';
  // }

  // return `building_focus_area_${selectedSubject}`;
}

const buildFocusAreaNext = ({ goToOnboardingQuestion, selectedSubject , deleteAll, isPreKindergarten }) => {
  // if (goToOnboardingQuestion) {
  //   return `onboarding_questions_${selectedSubject}`
  // }
  // redirectToDashboard({deleteAll});
  return isDRSWithCategoryExpansion() ? 'load_through_screen_1' : 'weekly_goal_screen';
}

const getFirstStep = () => (isDRSWithCategoryExpansion() ? 'program_selection_screen' : 'grade_selection');

const forkScreenNext = ({ goTo }) => goTo

const primingScreenNext = ({ selectedSubject }) => `onboarding_questions_${selectedSubject}`

const purchasePageNext = ({ onCross }) => {
  if(onCross)
    return "signup_page";
}

const lpScreenNext = () =>{
  return 'purchase_page'
}

const weeklyGoalNext = ({selectedSubject, deleteAll, skippedOnboarding}) =>{
  redirectToDashboard({deleteAll, skippedOnboarding});
  // return `building_focus_area_${selectedSubject}`;
  // return redirectToDashboard({deleteAll});
}

export const redirectToDashboard = async ({deleteAll, redirectToLPBookingScreen, redirectToPurchase, skippedOnboarding}) =>{
  await CompleteOnboarding();
  if(skippedOnboarding) {
    await TrackWeeklyGoalOnboarding();
  }
  deleteAll();
  if(hasSignedUpFromWs()) {
    try {
      await TrackWeeklyGoalOnboarding();
      saveHeaderVariationInStorage(TypesOfModes['Printables']);
      sessionStorage.setItem('activeTabCode', PRINTABLES);
      setDefaultTabPrintablesInStorage(PRINTABLES);
    }
    catch(e) {
      console.log('Error in track_weekly_goal_onboarding API', e);
    }
  }
  if(redirectToLPBookingScreen)
    return location.href = "/parent-dashboard/#lp-booking"

  return location.href = "/parent-dashboard"
}

const personalizeLpNext = ({code, selectedSubject}) => {
  const skipSubjectSelection = skipGradesForSubjectSelection();
  if(code == 'no_skip') {
    return isDRSWithCategoryExpansion() ? 'load_through_screen_1' : 'weekly_goal_screen';
  }
  else {
    return isDRSWithCategoryExpansion() && !skipSubjectSelection ? 'subject_selection' : `onboarding_questions_${selectedSubject}`;
  }
}

export const programSelectionScreenNextStep = ({ programName }) => {
  if(programName == EARLY_LEARNING_PROGRAM) {
    return 'age_selection_v2'
  }
  else {
    return 'grade_selection';
  }
}

export const ageSelectionV2NextStep = () => {
  return 'program_description_screen'
}

export const programDescriptionScreenNextStep = () => {
  return 'persona_identification'
}

export const loadThroughScreenOneNextStep = () => {
  const { selectedPersonalize } = getItemFromLocalStorage('splashverse-onboarding');
  const isSelectedPersonalizeYes = selectedPersonalize == 'yes_personalize';
  return isSelectedPersonalizeYes ? 'weekly_goal_screen' : 'load_through_screen_2';
}

export const loadThroughScreenTwoNextStep = () => {
  return 'load_through_screen_3';
}

export const loadThroughScreenThreeNextStep = () => {
  return 'weekly_goal_screen';
}

export const personaIdentificationNextStep = () => {
  return 'personalize_opt_in_screen';
}

export const getNextStep = {
  'first_step': getFirstStep,
  'child_screen_name': childScreenNameNextStep,
  'grade_selection': gradeSelectionNextStep,
  'age_selection': ageSelectionNextStep,
  'subject_selection': subjectSelectionNext,
  'onboarding_questions_math': onboardingQuestionsNext,
  'onboarding_questions_ela': onboardingQuestionsNext,
  'building_focus_area_math': buildFocusAreaNext,
  'building_focus_area_ela': buildFocusAreaNext,
  'fork_screen': forkScreenNext,
  'priming_screen': primingScreenNext,
  'purchase_page': purchasePageNext,
  'learning_partner_mapping_screen': lpScreenNext,
  'weekly_goal_screen': weeklyGoalNext,
  'personalize_opt_in_screen': personalizeLpNext,
  'program_selection_screen': programSelectionScreenNextStep,
  'age_selection_v2': ageSelectionV2NextStep,
  'program_description_screen': programDescriptionScreenNextStep,
  'load_through_screen_1': loadThroughScreenOneNextStep,
  'load_through_screen_2': loadThroughScreenTwoNextStep,
  'load_through_screen_3': loadThroughScreenThreeNextStep,
  'persona_identification': personaIdentificationNextStep
}